
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases",
      function () {
        return require("private-next-pages/cases/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cases"])
      });
    }
  